import { useCallback } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "components";

const ConfirmationDialog = ({
  isOpen = false,
  isDanger,
  title,
  contentText,
  onCancel,
  onConfirm,
  cancelText,
  confirmText,
  isConfirmLoading = false,
}) => {
  const { t } = useTranslation();

  const handleCancel = useCallback(() => {
    if (typeof onCancel === "function") {
      onCancel(false);
    }
  }, [onCancel]);

  const handleConfirm = useCallback(() => {
    if (typeof onConfirm === "function") {
      onConfirm();
    }
  }, [onConfirm]);

  return (
    <Dialog open={isOpen} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ minWidth: "500px", minHeight: "100px" }}>
        <DialogContentText id="alert-dialog-description">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {onCancel && (
          <Button onClick={handleCancel}>
            {cancelText || t("Global.Cancel")}
          </Button>
        )}
        {onConfirm && (
          <Button
            variant="filled"
            isLoading={isConfirmLoading}
            onClick={handleConfirm}
            color={isDanger ? "error" : "primary"}
          >
            {confirmText || t("Global.Confirm")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
